/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ModuleEEViewMore.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomDataGridV2 from "../../../common/datagrid/CustomDataGridV2";

import PropTypes from "prop-types";

function ModuleEEViewMore({ linkTableRows = [] }) {
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(25);
  const [slicedList, setSlicedList] = useState([]);

  const LINKED_COLUMN = [
    {
      field: "column1",
      headerName: "Component Details",
      flex: 1,
      renderCell: (params) => {
        const { assembly_number, version, description } = params?.value || {};
        const fontSize = "14px";
        const fontColor = "#53565A";
        return (
          <Box sx={{ fontSize: fontSize }}>
            <Typography
              sx={{ fontWeight: "bold", fontSize: fontSize }}
            >{`Assembly No: ${assembly_number || "-"}`}</Typography>
            <Typography
              sx={{ fontSize: fontSize, color: fontColor }}
            >{`Version: ${version || "-"}`}</Typography>
            <Typography
              sx={{ fontSize: fontSize, color: fontColor }}
            >{`Description: ${description || "-"}`}</Typography>
          </Box>
        );
      },
    },
    {
      field: "column2",
      headerName: "Network Details",
      flex: 1,
      renderCell: (params) => {
        const { network_interface, zone_details } = params?.value || {};
        const fontSize = "14px";
        return (
          <Box>
            <Typography sx={{ fontSize }}>
              <Box component="span" sx={{ fontWeight: "bold" }}>
                Network Interface:
              </Box>{" "}
              {network_interface || "-"}
            </Typography>

            <Typography sx={{ fontSize }}>
              <Box component="span" sx={{ fontWeight: "bold" }}>
                Zone Details:
              </Box>{" "}
              {zone_details?.zone_name || "-"}
            </Typography>
          </Box>
        );
      },
    },
  ];

  useEffect(() => {
    let slice = linkTableRows.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    );

    setSlicedList(slice);
  }, [page, linkTableRows, rowsPerPage]);

  return (
    <Box
      sx={{
        height: "290px",
      }}
    >
      <CustomDataGridV2
        columns={LINKED_COLUMN}
        rows={slicedList}
        hideHeadder={true}
        isMultiLine={true}
        showPagination={true}
        page={page}
        rowsPerPage={rowsPerPage}
        totalItems={linkTableRows.length}
        handlePageChange={(pageNo) => {
          setPage(pageNo);
        }}
      />
    </Box>
  );
}

ModuleEEViewMore.propTypes = {
  linkTableRows: PropTypes.array,
};

export default ModuleEEViewMore;
